import React from 'react'
import PropTypes from 'prop-types'
import ExportChoiceCards from './ExportChoiceCards'

const SECTION_SCOPE = 'Téléchargez toutes les photos de cette section en un seul fichier ZIP.'
const COLLECT_SCOPE = 'Téléchargez toutes les photos de cette collecte en un seul fichier ZIP.'

const PhotosOptions = ({ onExportAll, onCustomize, currentSectionId }) => (
  <ExportChoiceCards
    exportAllTitle="Exporter toutes les photos"
    exportAllDescription={currentSectionId ? SECTION_SCOPE : COLLECT_SCOPE}
    customizeDescription="Sélectionnez des sections et questions spécifiques pour un export ciblé."
    onExportAll={onExportAll}
    onCustomize={onCustomize}
  />
)

PhotosOptions.propTypes = {
  currentSectionId: PropTypes.number,
  onCustomize: PropTypes.func.isRequired,
  onExportAll: PropTypes.func.isRequired
}

PhotosOptions.defaultProps = {
  currentSectionId: null
}

export default PhotosOptions
